import { useEffect, useState } from 'react';

import useBaseUsasClubData from '@usas/ui-web/state/clubBase/UseBaseUsasClubData';

const INITIAL_VIEW_STATE = {
  reportParameters: { orgUnitId: '' },
  contextId: '',
  routeName: ''
};

const useClubReporting = () => {
  const [ viewState, setViewState ] = useState({...INITIAL_VIEW_STATE});
  const { baseUsasClubState } = useBaseUsasClubData();

  useEffect(() => {
    if (baseUsasClubState.objData?.orgUnitId) {
      setViewState({
        ...viewState,
        reportParameters: {orgUnitId: baseUsasClubState.objData.orgUnitId},
        contextId: baseUsasClubState.objData.orgUnitId,
        routeName: 'CLUB_REPORTING'
      });
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [baseUsasClubState.objData]);

  return {...viewState};
};

export default useClubReporting;